var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createGuid } from '@office-start/guid-generator';
import { OfficeHomeApp } from '@office-start/office-home-app';
import { OfficeWorkload } from '@office-start/officehome-types';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { ReactQueryDevtools } from 'react-query-devtools';
import { handlePathQuery } from './handlePathQuery';
export var renderReactOhome = function (appContext) {
    var _a, _b, _c, _d, _e;
    if (!appContext) {
        if (process.env.NODE_ENV === 'production') {
            console.error('No app context provided in production.');
        }
        else {
            console.warn('No app context provided. Using development context.');
        }
        // $TODO: If this is really development context, it should come from a mock API, webpack, .env or similar
        // and be bootstrapped from the page / webpack just like the production flow
        // TODO: Remove legacy network config fetches entirely
        var searchParams = new URLSearchParams(window.location.search);
        var disableLegacyNetworkConfigs = !!((_a = searchParams
            .get('flight')) === null || _a === void 0 ? void 0 : _a.toLowerCase().split(',').includes('disablelegacynetworkconfigs'));
        appContext = {
            buildDateUtc: new Date().toISOString(),
            buildVersion: '1.0',
            cdnDomain: 'res-1-sdf.cdn.office.net/officehub',
            correlationId: createGuid(),
            // OfficeEnvironment if used as an enum is undefined here.
            deploymentEnvironment: 'Dev',
            disableLegacyNetworkConfigs: disableLegacyNetworkConfigs,
            domainOrigin: 'Microsoft365',
            geoName: 'wus',
            inMockMode: true,
            isCorpNet: false,
            mockReactShell: true,
            officeHomeApiRoot: "http://localhost:".concat(process.env.MOCK_API_PORT_NUMBER || 5000, "/mock"),
            officeMarketLcid: 1033,
            officeStartManifestVersion: '7834100',
            preferredCulture: 'en-US',
            requestOrigin: 'Direct',
            sessionId: '00000000-0000-0000-0000-000000000000',
            stringsContainerName: 'officestartstrings',
            useLocalFiles: true,
            testTraffic: false,
            appSwitchUrl: '',
            appSwitchToUrl: '',
            thirdPartyNoticeUrl: '',
            logoutUrl: '',
        };
    }
    // Inject other missing properties from OfficeReactStartupConfiguration that are expected to be on the context
    // When this moves into office-home-app, we can merge this with other configs to fully populate it
    // (or move it into some other type to make more sense from a client perspective)
    var Windows = window === null || window === void 0 ? void 0 : window.Windows;
    if (!appContext.wrapperVersion && Windows) {
        appContext = __assign(__assign({}, appContext), { wrapperVersion: (_e = (_d = (_c = (_b = Windows === null || Windows === void 0 ? void 0 : Windows.ApplicationModel) === null || _b === void 0 ? void 0 : _b.Package) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.version });
    }
    var webContext = {
        aadAppId: '4345a7b9-9a63-4910-a426-35363201d503',
        workload: OfficeWorkload.OfficeHomeReact,
        defaultLinkTarget: '_blank',
        jwtAuthEnabled: false,
    };
    ReactDOM.render(_jsxs(_Fragment, { children: [_jsx(StrictMode, { children: _jsx(OfficeHomeApp, { props: appContext, commonContext: webContext }) }), _jsx(ReactQueryDevtools, { initialIsOpen: false })] }), document.getElementById('root'));
    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    //serviceWorker.unregister();
    handlePathQuery(appContext.browserPathAndQueryString || '');
};
